// const PQueue = require('p-queue');
import PQueue from 'p-queue';

class RestApiConnector {
  constructor() {
    this.dataLoadedEventKey = 'dataLoaded';
  }

  init() {
    this.pq = new PQueue({
      concurrency: 2,
    });
  }

  loadData(routeWithParams, contentType = 'application/json', additionalHeaders = {}, checkStatus = false) {
    const requestHeaders = new Headers(additionalHeaders);
    requestHeaders.append('Content-Type', contentType);

    return this.pq.add(() => new Promise((resolve, reject) => {
      fetch(routeWithParams, {
        method: 'GET',
        headers: requestHeaders,
      })
        .then((response) => {
          if (checkStatus && response.status === 204) {
            // don't reload if empty content
            return;
          }
          resolve(contentType === 'application/json' ? response.json()
            .then(data => ({ status: response.status, ...data })) : response.text());
        })
        .catch((error) => {
          // console.info('Error occurred');
          // console.error(error);
          reject(error);
        });
    })
      .catch(() => {}));
  }

  sendData(routeWithParams, body, contentType, suppressError = false, additionalHeaders = false) {
    const requestHeaders = new Headers();
    if (contentType) {
      requestHeaders.append('Content-Type', contentType);
    }

    if (additionalHeaders) {
      additionalHeaders.forEach((additionalHeader) => {
        requestHeaders.append(additionalHeader.name, additionalHeader.value);
      });
    }

    return this.pq.add(() => new Promise((resolve, reject) => {
      fetch(routeWithParams, {
        method: 'POST',
        headers: requestHeaders,
        body,
      })
        .then((response) => {
          const responseContentType = response.headers.get('content-type');
          if (responseContentType && responseContentType.includes('json')) {
            resolve(response.json()
              .then(data => ({ status: response.status, ...data })));
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          // console.info('error occured');
          // console.error(error);
          reject(error);
        });
    })
      .catch(() => {
        if (!suppressError) {
          // console.info('2. Error occurred');
          // console.error(error);
        }
      }));
  }
}

export default RestApiConnector;



// WEBPACK FOOTER //
// ./src/javascript/restApi/index.js